<template>
  <div>
    <v-layout row v-if="errors" class="mx-1 mt-2">
      <v-flex>
        <Alert @dismissed="onDismissed" :text="errors"></Alert>
      </v-flex>
    </v-layout>
    <v-container>
      <v-progress-linear
        indeterminate
        color="blue"
        v-if="loading"
      ></v-progress-linear>
      <v-row>
        <v-col sm="12" md="12" lg="9">
          <project-header
            :project="project"
            @update-status="handleUpdateStatus"
            @update-priority="handleUpdatePriority"
            :statics="statics"
          />
        </v-col>
        <v-col
          sm="12"
          md="12"
          lg="3"
          v-if="hasPermission('project.members_view')"
        >
          <TeamMembers
            v-if="hasPermission('project.members_view')"
            :project="project"
            @members-add="handleAddMembers"
            @members-delete="handleDeleteMembers"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          sm="12"
          md="12"
          v-if="
            hasPermission('project.task_list_view') ||
            hasPermission('task.assignee_list')
          "
        >
          <ToDoList
            v-if="
              hasPermission('project.task_list_view') ||
              hasPermission('task.assignee_list')
            "
            :project="project"
            :multiUser="taskMultiUser"
            :estUnit="estimationUnit"
            @task-created="handleTaskCreated"
            @update-task-status="handleUpdateTaskStatus"
            @delete-task="handleDeleteTask"
            @task-update="handleUpdateTaskDetails"
          />
        </v-col>
        <v-col sm="12" md="6">
        <v-tabs v-model="activeTab" color="#00B3FF">
          <v-tab v-if="hasPermission('document.project_document_upload') || hasPermission('document.project_document_download')">Attachments</v-tab>
          <v-tab v-if="hasPermission('project.message_view')">Comments</v-tab>
          <v-tab v-if="hasPermission('project.recent_activity_view')">Recent Activity</v-tab>
        </v-tabs>
      <v-tabs-items v-model="activeTab">
        <v-tab-item>
            <Attachments
              v-if="hasPermission('document.project_document_upload') || hasPermission('document.project_document_download')"
              :project="project"
              :taskData="false"
              @documents-upload="handleDocumentsUpload"
              @documents-download="handleDocumentsDownload"
              @documents-delete="handleDocumentsDelete"
            />
        </v-tab-item>
        <v-tab-item>
            <comments
              v-if="hasPermission('project.message_view')"
              :commentsData="project.project_comments"
              @add-comments="handleAddComments"
              @delete-comments="handleDeleteComments"
            />
        </v-tab-item>
        <v-tab-item>
            <RecentActivity
              v-if="hasPermission('project.recent_activity_view')"
              :activityLogs="project.project_logs"
            />
        </v-tab-item>
      </v-tabs-items>
      </v-col>
        <v-col sm="12" md="6">
          <Invoices v-if="hasPermission('invoice.list_project')" />
        </v-col>
      </v-row>
    </v-container>
    <Snackbars
      :text="succesMsg"
      :snackbar="snackbar"
      :color="snackColor"
      @classSnackbar="clossSnackbar"
    />
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");
import { ProjectService } from "@/services/project-service.js";
import TeamMembers from "@/components/shared/TeamMembers.vue";
import ToDoList from "@/components/shared/ToDoList.vue";
import Attachments from "@/components/shared/Attachments.vue";
import ProjectHeader from "@/components/shared/ProjectHeader.vue";
import Comments from "@/components/shared/Comments.vue";
import { fileService } from "@/config/file-service.js";
import RecentActivity from "@/components/shared/RecentActivity.vue";
import Alert from "@/components/shared/Alert";
import Snackbars from "@/components/shared/Snackbars";
import Invoices from "@/components/shared/ProjectInvoice.vue";
import { TaskService } from "@/services/task-service.js";
import { checkError } from "@/config/errors.js";
import { SettingsService } from "../../services/setting-service.js";

export default {
  name: "ProjectDetails",

  components: {
    TeamMembers,
    ToDoList,
    Attachments,
    ProjectHeader,
    Comments,
    RecentActivity,
    Alert,
    Snackbars,
    Invoices,
  },

  data: () => ({
    activeTab: 0,
    project: {},
    defaultImage: require("@/assets/img/avatar.svg"),
    errors: null,
    snackbar: false,
    succesMsg: "",
    snackColor: "success",
    loading: false,
    statics: {},
    taskMultiUser: false,
    estimationUnit: "Hours",
  }),

  mounted() {
    this.getProjectInfo();
    this.getProjectTaskStatics();
    this.getProjectSettings();
  },

  computed: {
    ...mapGetters({
      member: "profile",
      hasPermission: "hasPermission",
    }),
  },

  methods: {
    getProjectInfo() {
      this.loading = true;
      ProjectService.getProjectInfo(this.$route.params.uuid)
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.scrollToTop();
            this.project = response.data.data;
            this.getProjectTaskStatics();
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          this.errors = data;
        });
    },
    getProjectTaskStatics() {
      this.loading = true;
      ProjectService.getProjectTaskStatics(this.$route.params.uuid)
        .then((response) => {
          this.loading = false;
          if (response.data) {
            this.statics = response.data;
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          this.errors = data;
        });
    },
    handleTaskCreated(newTask) {
      ProjectService.createTask(this.$route.params.uuid, newTask)
        .then((response) => {
          this.loading = false;
          if (response.data) {
            this.succesMsg = "Task Created Successfully";
            this.snackbar = true;
          }
          this.$emit('task-created-success');
          this.getProjectInfo();
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          this.$emit('task-created-error', data);
        });
    },
    handleDocumentsUpload(documents) {
      this.loading = true;
      ProjectService.documentUpload(this.$route.params.uuid, documents)
        .then((response) => {
          this.loading = false;
          if (response.data) {
            this.succesMsg = "Document Uploaded Successfully";
            this.snackbar = true;
          }
          this.getProjectInfo();
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          this.errors = data;
        });
    },
    handleDocumentsDownload(uuid) {
      this.loading = true;
      ProjectService.downloadDocuments(uuid)
        .then((response) => {
          const contentType = response.headers["content-type"];
          const matches = contentType.match(/filename="(.+?)\.(.+?)"/);
          if (matches && matches.length === 3) {
            const fileName = matches[1];
            const fileExtension = matches[2];
            fileService.downloadFile(
              response.data,
              "",
              fileExtension,
              fileName
            );
            this.loading = false;
            this.succesMsg = "Document Downloaded Successfully";
            this.snackbar = true;
          }
        })
        .catch((error) => {
          this.loading = false;
          error.response.data;
          this.errors = ["File Not Found"];
        });
    },
    handleAddMembers(members) {
      let fd = new FormData();
      fd.append("member_id", members);
      ProjectService.addProjectMembers(this.$route.params.uuid, fd)
        .then((response) => {
          this.loading = false;
          if (Object.keys(members).length !== 0 && response.data) {
            this.succesMsg = "Member Added Successfully";
            this.snackbar = true;
          } else {
            this.succesMsg = "Members are not Selected";
            this.snackColor = "warning";
            this.snackbar = true;
          }
          this.getProjectInfo();
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          this.errors = data;
        });
    },
    handleDocumentsDelete(document) {
      let fd = new FormData();
      fd.append("uuid", document);
      this.loading = true;
      ProjectService.deleteDocument(this.$route.params.uuid, fd)
        .then((response) => {
          this.loading = false;
          if (response.data) {
            this.succesMsg = "Document Deleted Successfully";
            this.snackbar = true;
          }
          this.getProjectInfo();
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          this.errors = data;
        });
    },
    handleAddComments(comment) {
      let fd = new FormData();
      fd.append("comment", comment);
      ProjectService.addProjectComments(this.$route.params.uuid, fd)
        .then((response) => {
          this.loading = false;
          if (response.data) {
            this.succesMsg = "Comment Added Successfully";
            this.snackbar = true;
          }
          this.getProjectInfo();
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          this.errors = data;
        });
    },
    handleDeleteComments(comment, permission) {
      let fd = new FormData();
      fd.append("uuid", comment);
      fd.append("auth_permission", permission);
      ProjectService.deleteProjectComments(this.$route.params.uuid, fd)
        .then((response) => {
          this.loading = false;
          if (response.data) {
            this.succesMsg = "Comment Deleted Successfully";
            this.snackbar = true;
          }
          this.getProjectInfo();
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          this.errors = data;
        });
    },
    handleDeleteMembers(member) {
      let fd = new FormData();
      fd.append("member_id", member);
      ProjectService.deleteProjectMembers(this.$route.params.uuid, fd)
        .then((response) => {
          this.loading = false;
          if (response.data) {
            this.succesMsg = response.data.message;
            this.snackbar = true;
          }
          this.getProjectInfo();
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },
    handleUpdateStatus(status) {
      this.errors = null;
      let fd = new FormData();
      fd.append("status", status);
      ProjectService.updateProjectStatus(this.$route.params.uuid, fd)
        .then((response) => {
          this.loading = false;
          if (response.data) {
            this.succesMsg = "Status Updated Successfully";
            this.snackbar = true;
          }
          this.getProjectInfo();
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          this.errors = data;
        });
    },
    handleUpdatePriority(priority) {
      let fd = new FormData();
      fd.append("priority", priority);
      ProjectService.updateProjectPriority(this.$route.params.uuid, fd)
        .then((response) => {
          this.loading = false;
          if (response.data) {
            this.succesMsg = "Priority Updated Successfully";
            this.snackbar = true;
          }
          this.getProjectInfo();
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          this.errors = data;
        });
    },
    handleUpdateTaskStatus(data) {
      let fd = new FormData();
      fd.append("status", data.status);
      this.onDismissed();
      TaskService.updateTaskStatus(data.uuid, fd)
        .then((response) => {
          this.loading = false;
          if (response.data) {
            this.succesMsg = response.data.message;
            this.snackbar = true;
          }
          this.getProjectInfo();
          this.$emit('task-updated-success');
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },
    handleDeleteTask(uuid) {
      TaskService.deleteTask(uuid)
        .then((response) => {
          this.loading = false;
          if (response.data) {
            this.succesMsg = response.data.message;
            this.snackbar = true;
          }
          this.getProjectInfo();
          this.$emit('task-updated-success');
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          this.errors = data;
        });
    },
    getProjectSettings() {
      SettingsService.getProjectSettings()
        .then((response) => {
          const settings = response.data.data;

          const multiUserSetting = settings.find(
            (setting) => setting.key === "tasks_muti_user_enable"
          );
          if (multiUserSetting) {
            let value = multiUserSetting.value;
            if (value === "true" || value === "false") {
              value = value === "true";
            }
            this.taskMultiUser = value;
          }

          const estimationUnitSetting = settings.find(
            (setting) => setting.key === "estimation_unit"
          );
          if (estimationUnitSetting) {
            let value = estimationUnitSetting.value;
            if (value) {
              this.estimationUnit = value;
            } else {
              this.estimationUnit = "Hours"; // Default value
            }
          }

          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.errors = checkError.errorFormatting(error.response.data);
        });
    },
    handleUpdateTaskDetails(data) {
      this.errors = null;
      TaskService.updateTaskDetails(this.$route.params.uuid, data)
        .then((response) => {
          this.loading = false;
          if (response.data) {
            this.succesMsg = "Task Updated Successfully";
            this.snackbar = true;
            this.$emit('task-updated-success');
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          this.$emit('task-created-error', data);
        });
    },
    onDismissed() {
      this.errors = null;
    },
    clossSnackbar() {
      this.snackbar = false;
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },
};
</script>
